import { insights, userService } from '@saucelabs/sl-util-axios';

import { TEAM_API_DEFAULT_PARAMS } from '../../constants';

/**
 * @param {Object} params
 * @param {number} params.limit
 * @param {number} params.offset
 */
export const getUsers = ({ limit = 100, offset = 0, phrase } = {}) => (
  userService.get('/v1/users/', { params: { limit, offset, phrase } })
);

export const getTeams = (params) => (
  userService.get('/v1/teams/', { params: { ...TEAM_API_DEFAULT_PARAMS, ...params } })
);

/**
 * @param {Object} params
 * @param {Array}  params.{string} - Filters are passed as a string key and value as an array.
 */
export function getTrends({ cloudType = 'vdc', ...params }) {
  return insights.get(`${cloudType}/trends/tests`, { params });
}

/**
 * @param {Object} params
 * @param {Array}  params.{string} - Filters are passed as a string key and value as an array.
 */
export function getAggregatedTestErrors({ cloudType = 'vdc', ...params }) {
  return insights.get(`${cloudType}/trends/errors`, { params });
}

/**
 * @param {Object} params
 * @param {Array} params.{string} - Filters are passed as a string key and value as an array
 */
export function getTests({ cloudType = 'vdc', ...params }) {
  return insights.get(`${cloudType}/tests`, { params });
}

/**
 * @param {Object} params
 * @param {Array} params.{string} - Filters are passed as a string key and value as an array
 */
export function getTestCases({ cloudType = 'vdc', ...params }) {
  return insights.get(`${cloudType}/test-cases`, { params });
}

/**
 * @param {Object} params
 * @param {Array}  params.{string} - Filters are passed as a string key and value as an array.
 */
export function getTestHealth({ cloudType = 'vdc', ...params }) {
  return insights.get(`/${cloudType}/test-cases/stats`, { params });
}

/**
 * @param {Object} params
 * @param {Object} params.queryParams
 * @param {Array} params.queryParams.{string} -
 * Filters are passed as a string key and value as an array
 */
export function getTestCasesCSV({ cloudType = 'vdc', queryParams }) {
  return insights.get(`${cloudType}/test-cases/csv`, { params: queryParams });
}

/**
 * @param {Object} params
 * @param {Array} params.{string} - Filters are passed as a string key and value as an array
 */
export function getTestCasesTrends({ cloudType = 'vdc', ...params }) {
  return insights.get(`${cloudType}/test-cases/trends`, { params });
}

/**
 * @param {Object} params
 * @param {Array}  params.{string} - Filters are passed as a string key and value as an array.
 */
export function getBuildsTests({ cloudType = 'vdc', ...params }) {
  return insights.get(`${cloudType}/trends/builds_tests`, { params });
}

export function getBrowserCoverage({ cloudType = 'vdc', ...params }) {
  return insights.get(`${cloudType}/coverage/browser`, { params });
}

export function getDeviceCoverage({ cloudType = 'vdc', ...params }) {
  return insights.get(`${cloudType}/coverage/device`, { params });
}

export function getOsCoverage({ cloudType = 'vdc', ...params }) {
  return insights.get(`${cloudType}/coverage/os`, { params });
}

export function getBrowserCoverageCSV({ cloudType = 'vdc', ...params }) {
  return insights.get(`${cloudType}/coverage/browser/csv`, { params });
}

export function getDeviceCoverageCSV({ cloudType = 'vdc', ...params }) {
  return insights.get(`${cloudType}/coverage/device/csv`, { params });
}

export function getOsCoverageCSV({ cloudType = 'vdc', ...params }) {
  return insights.get(`${cloudType}/coverage/os/csv`, { params });
}

export function getFilters({ cloudType = 'vdc', ...params }) {
  return insights.get(`${cloudType}/filters`, { params });
}

export const getConcurrencyReport = ({ queryParams: { cloudType, ...params } }) => (
  insights.get(`${cloudType}/concurrency/max/csv`, { params })
);
